/**
 * A service that provides data to ensure that employees have acknowledged
 * any changes made to their time entries by their employer.
 */
export class TimeEntryComplianceService {
    constructor($http, apexApiUrl) {
        'ngInject'
        this.$http = $http
        this.apexApiUrl = apexApiUrl
    }

    /**
     * Get the list of time entries for the current user that have been modified
     * by another user and have not been acknowledged.
     */
    retrieveModifiedTimeEntries() {
        return this.$http({
            method: "GET",
            url: `${this.apexApiUrl}/time-entries/modified`
        }).then(response => response.data)
    }

    /**
     * Get the list of users who have modified time entries belonging to the current user,
     * along with the number of time entries that were modified.
     */
    countModifiedTimeEntriesByEmployee() {
        return this.$http({
            method: "GET",
            url: `${this.apexApiUrl}/time-entries/modified/count-by-employee`
        }).then(response => response.data)
    }

    /**
     * Acknowledge the specific modification to the current user's time entries.
     * @param {number} timeEntryModificationID The modification to acknowledge
     */
    acknowledgeTimeEntryModification(timeEntryModificationID) {
        return this.$http({
            method: "PUT",
            url: `${this.apexApiUrl}/time-entries/modified/${timeEntryModificationID}/acknowledge`
        })
    }

    /**
     * Get the list of the modifications made by the current user that have not been acknowledged
     * by the reps.
     */
    retrieveUnacknowledgedTimeEntryModifications() {
        return this.$http({
            method: "GET",
            url: `${this.apexApiUrl}/time-entries/modifications`
        }).then(response => response.data)
    }

    retrieveTimeEntryModificationHistory(timeEntryModificationID) {
        return this.$http({
            method: "GET",
            url: `${this.apexApiUrl}/time-entry-modifications/${timeEntryModificationID}/history`
        }).then(response => response.data)
    }
}
